varying vec3 vPositionW;
varying vec3 vNormalW;
varying vec2 vUv;
varying float vCarrierDistance;
uniform vec3 uCarrierPosition;

void main() {
  vUv = uv;
  vPositionW = (modelMatrix * vec4(position, 1.0)).xyz;
  vNormalW = normalize(mat3(modelMatrix[0].xyz, modelMatrix[1].xyz, modelMatrix[2].xyz) * normal);

  vCarrierDistance = distance(vPositionW, uCarrierPosition);
  gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);

}